// Re-exports `useAuth` from WorkOS alongside our AuthProvider wrapper.
// Splitting them into separate files would be churn — this file is the
// auth boundary. Fast refresh is OK to lose on this tiny re-export shim.
/* eslint-disable react-refresh/only-export-components */
import { AuthKitProvider, useAuth } from "@workos-inc/authkit-react";

export { useAuth };

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <AuthKitProvider
      clientId={import.meta.env.VITE_WORKOS_CLIENT_ID}
      redirectUri={import.meta.env.VITE_WORKOS_REDIRECT_URI || `${window.location.origin}/callback`}
      // devMode keeps refresh token in localStorage instead of secure cookie.
      // Required until a custom auth domain (e.g. auth.misplot.com) is set up in WorkOS.
      devMode
    >
      {children}
    </AuthKitProvider>
  );
}
